var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [_c("header-item"), _vm._v(" "), _c("list-item"), _vm._v(" "), _c("gotop")],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }